import React from "react";

interface FieldWithIconProps {
    imageUrl: string
    fieldValue: string
}

export const FieldWithIcon: React.FC<FieldWithIconProps> = ({imageUrl, fieldValue}) => {
    return <span
        className="inline-flex items-center gap-1 whitespace-nowrap py-1.5">
        <img
            src={imageUrl}
            alt={`${fieldValue} image`}
            className="w-3 h-4"
        />
        <span className="text-sm font-semibold">{fieldValue}</span>
    </span>
}
